import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, User, Briefcase, Wallet, Phone, FileText } from "lucide-react";



const PersonalInformation = () => {
const [formData, setFormData] = useState({
  employee_code: "",
  first_name: "",
  middle_name: "",
  last_name: "",
  preferred_name: "",
  gender: "",
  date_of_birth: "",
  blood_group: "",
  marital_status: "",
  nationality: "",
  languages_known: "",
  personal_email: "",
  official_email: "",
  primary_phone: "",
  secondary_phone: "",
  remarks: "",
});

const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value,
  });
};
 const navigate = useNavigate();

const [photo, setPhoto] = useState(null);
const [preview, setPreview] = useState(null);

const handlePhotoUpload = (e) => {
  const file = e.target.files[0];

  if (file) {
    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  }
};

const handleNext = () => {
  navigate("/hr/employee/add/employment");
};
  return (
    <div className="min-h-screen bg-slate-50 p-6">
      {/* Header */}
      <div className="mb-6">
       <button
  onClick={() => navigate("/hr/employee")}
  className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition"
>
  ← Back to Employees
</button>

        <h1 className="text-4xl font-bold text-slate-900">
          Add Employee
        </h1>

        <p className="text-slate-500 mt-2">
          Create a new employee profile and complete onboarding.
        </p>
      </div>

      {/* Stepper */}
      <div className="bg-white rounded-2xl border p-5 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex flex-col items-center text-blue-600">
            <User size={22} />
            <span className="text-sm font-medium mt-2">
              Personal
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4" />

          <div className="flex flex-col items-center text-slate-400">
            <Briefcase size={22} />
            <span className="text-sm mt-2">
              Employment
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4" />

          <div className="flex flex-col items-center text-slate-400">
            <Wallet size={22} />
            <span className="text-sm mt-2">
              Salary
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4" />

          <div className="flex flex-col items-center text-slate-400">
            <Phone size={22} />
            <span className="text-sm mt-2">
              Emergency
            </span>
          </div>

          <div className="flex-1 h-1 bg-slate-200 mx-4" />

          <div className="flex flex-col items-center text-slate-400">
            <FileText size={22} />
            <span className="text-sm mt-2">
              Documents
            </span>
          </div>
        </div>
      </div>

      {/* Main Card */}
      <div className="bg-white rounded-2xl border shadow-sm p-8">
        <h2 className="text-2xl font-semibold mb-8">
          Personal Information
        </h2>

        <div className="grid grid-cols-12 gap-8">
          {/* Upload Photo */}
       <div className="col-span-12 lg:col-span-3">
  <label className="block text-sm font-medium mb-3">
    Profile Photo
  </label>

  <label className="border-2 border-dashed border-slate-300 rounded-2xl h-64 flex flex-col justify-center items-center cursor-pointer hover:border-blue-500 transition overflow-hidden">

    {preview ? (
      <img
        src={preview}
        alt="Profile Preview"
        className="w-full h-full object-cover"
      />
    ) : (
      <>
        <p className="font-medium">
          Upload Photo
        </p>

        <p className="text-sm text-slate-500">
          JPG, PNG up to 2MB
        </p>
      </>
    )}

    <input
      type="file"
      accept="image/*"
      className="hidden"
      onChange={handlePhotoUpload}
    />
  </label>
</div>

          {/* Form Fields */}
          <div className="col-span-12 lg:col-span-9">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">

              <input
                type="text"
                placeholder="Employee Code"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="First Name"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="Middle Name"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="Last Name"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="Preferred Name"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <select className="w-full px-4 py-3 bg-slate-50 border rounded-xl">
                <option>Gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>

              <input
                type="date"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <select className="w-full px-4 py-3 bg-slate-50 border rounded-xl">
                <option>Blood Group</option>
                <option>A+</option>
                <option>A-</option>
                <option>B+</option>
                <option>AB+</option>
                <option>O+</option>
              </select>

              <select className="w-full px-4 py-3 bg-slate-50 border rounded-xl">
                <option>Marital Status</option>
                <option>Single</option>
                <option>Married</option>
                <option>Separated</option>
              </select>

              <input
                type="text"
                placeholder="Nationality"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="Languages Known"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="email"
                placeholder="Personal Email"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="email"
                placeholder="Official Email"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="Primary Phone"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />

              <input
                type="text"
                placeholder="Secondary Phone"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />
            </div>

            <div className="mt-6">
              <textarea
                rows={4}
                placeholder="Remarks"
                className="w-full px-4 py-3 bg-slate-50 border rounded-xl"
              />
            </div>
          </div>
        </div>

        {/* Next Button */}
        <div className="flex justify-end mt-10">
         <button
  type="button"
  onClick={handleNext}
  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-xl font-medium"
>
  Next →
</button>
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;